<template>
  <div class="confirm-research-modal-mask" v-show="visible">
    <div class="confirm-research-modal">
      <!-- 弹窗头部：保留提示语+本地图片图标 + 动态业务标题 + 关闭按钮 -->
      <div class="modal-header">
        <div class="modal-title-wrap">
          <span class="business-subtitle">{{ businessType }}</span>
          <!-- 调试：显示 compExch -->
          <span style="color: red; font-size: 12px;"></span>
          <span class="prompt-text">
            <img 
              class="headset-icon"
              src="@/assets/icons/headset-icon.png"
              alt="耳机图标"
            />
            请您确认以下信息，如果确认无误，我们将尽快安排调研！
          </span>
        </div>
        <button class="close-btn" @click="handleClose">×</button>
      </div>
      <!-- 弹窗内容：信息展示区域 -->
      <div class="modal-content">
        <!-- 公司信息：仅立项时显示（只展示名称，ID隐藏） -->
        <div class="info-item" v-if="businessType === '立项' && companyInfo">
          <span class="info-label">公司名称：</span>
          <span class="info-value">{{ companyInfo.compName }}</span>
          <!-- 公司ID：隐藏，仅提交时携带 -->
          <input  type="hidden" :value="companyInfo.compId"/>
        </div>

        <!-- 业务子类：委托买壳时显示 -->
        <div class="info-item" v-if="businessType === '委托卖/买壳'">
          <span class="info-label">业务类型：</span>
          <div class="radio-group">
            <label class="radio-label">
              <input type="radio" v-model="internalInfo.sub_type" value="买壳" />
              <span>买壳</span>
            </label>
            <label class="radio-label">
              <input type="radio" v-model="internalInfo.sub_type" value="卖壳" />
              <span>卖壳</span>
            </label>
          </div>
        </div>

        <!-- 业务子类：委托调研时显示 -->
        <div class="info-item" v-if="businessType === '委托调研'">
          <span class="info-label">调研类型：</span>
          <div class="radio-group">
            <label class="radio-label">
              <input type="radio" v-model="internalInfo.sub_type" value="尽职调查" />
              <span>尽职调查</span>
            </label>
            <label class="radio-label">
              <input type="radio" v-model="internalInfo.sub_type" value="普通调查" />
              <span>普通调查</span>
            </label>
          </div>
        </div>

        <!-- 业务子类：委托定增时显示 -->
        <div class="info-item" v-if="businessType === '委托定增'">
          <span class="info-label">定增类型：</span>
          <div class="radio-group">
            <label class="radio-label">
              <input type="radio" v-model="internalInfo.sub_type" value="询价" />
              <span>询价</span>
            </label>
            <label class="radio-label">
              <input type="radio" v-model="internalInfo.sub_type" value="发行" />
              <span>发行</span>
            </label>
          </div>
        </div>

        <!-- 公司名称输入：委托调研时显示 -->
        <div class="info-item" v-if="businessType === '委托调研'">
          <span class="info-label">公司名称：</span>
          <el-select
            v-model="internalInfo.selectedCompCode"
            placeholder="输入公司代码/名称搜索"
            filterable
            remote
            reserve-keyword
            :remote-method="handleCompanySearch"
            :loading="searchLoading"
            @change="handleCompanySelect"
            clearable
            class="company-select"
          >
            <el-option
              v-for="item in companyList"
              :key="item.id"
              :label="`${item.comp_exch}.${item.comp_code} - ${item.comp_name}`"
              :value="item.comp_code"
            >
            </el-option>
          </el-select>
        </div>

        <!-- 公司名称输入：委托定增 或 委托买壳选择卖壳时显示 -->
        <div class="info-item" v-if="businessType === '委托定增' || (businessType === '委托卖/买壳' && internalInfo.sub_type === '卖壳')">
          <span class="info-label">公司名称：</span>
          <el-select
            v-model="internalInfo.selectedCompCode"
            placeholder="输入公司代码/名称搜索"
            filterable
            remote
            reserve-keyword
            :remote-method="handleCompanySearch"
            :loading="searchLoading"
            @change="handleCompanySelect"
            clearable
            class="company-select"
          >
            <el-option
              v-for="item in companyList"
              :key="item.id"
              :label="`${item.comp_exch}.${item.comp_code} - ${item.comp_name}`"
              :value="item.comp_code"
            >
            </el-option>
          </el-select>
        </div>

        <!-- 用户信息（均改为可编辑输入框） -->
        <div class="info-item">
          <span class="info-label">对接人：</span>
          <input class="info-input" v-model="internalInfo.projectContact" placeholder="请输入对接人姓名" />
          <span class="info-label">电话：</span>
          <input class="info-input phone-input" v-model="internalInfo.contactPhone" placeholder="请输入联系电话" maxlength="11" @input="handlePhoneInput"/>
        </div>
        <div class="info-item">
          <span class="info-label">电子邮件：</span>
          <!-- 邮箱输入框：与特殊说明宽度一致 -->
          <input class="info-input email-input" v-model="internalInfo.contactEmail" placeholder="请输入电子邮件" @input="handleEmailInput"/>
        </div>
        <div class="info-item">
          <span class="info-label">特殊说明：</span>
          <textarea class="special-note" v-model="internalInfo.business_desc" placeholder="请输入特殊说明"></textarea>
        </div>
        <p class="modifiable-tip">上述内容可修改</p>
        <p class="contact-phone">子沐研究电话：(<a href="tel:18611097778">18611097778</a>)</p>
      </div>
      <div class="modal-footer">
        <button class="btn cancel-btn" @click="handleClose">取消</button>
        <button class="btn confirm-btn" @click="handleConfirm" :disabled="!isFormValid">确认提交</button>
      </div>
    </div>
  </div>
</template>

<script>
import { companyApi } from '@/api/index';
import { useUserStore } from '@/store/userStore.js';

export default {
  name: 'ConfirmResearchModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    // 业务类型：委托定增/委托买壳/立项/委托调研
    businessType: {
      type: String,
      required: true,
      validator: (val) => ['委托定增', '委托卖/买壳', '立项', '委托调研'].includes(val)
    },
    // 用户信息（从父组件传入，作为默认值）
    userInfo: {
      type: Object,
      default: () => ({
        projectContact: '',
        contactPhone: '',
        contactEmail: ''
      })
    },
    // 公司信息（仅立项时传入）
    companyInfo: {
      type: Object,
      default: () => ({
        compName: '',
        compId: '' // ID仅用于提交，不展示
      }),
      validator: (val) => {
        // 校验：如果传入，必须包含compName和compId
        if (val.compName || val.compId) {
          return !!val.compName && !!val.compId;
        }
        return true;
      }
    },
    // 其他信息
    info: {
      type: Object,
      default: () => ({
        business_desc: '',
        from: ''
      }),
    },
    // 交易所类型（用于委托调研时限制公司搜索范围）
    compExch: {
      type: String,
      default: ''
    }
  },
  computed: {
    // 表单验证：对接人、电话、邮箱为必填项
    isFormValid() {
      const basicValid = !!this.internalInfo.projectContact && 
                        !!this.internalInfo.contactPhone && 
                        this.validateEmail(this.internalInfo.contactEmail);
      
      if (this.businessType === '委托卖/买壳') {
        if (!this.internalInfo.sub_type) {
          return false;
        }
        // 选择卖壳时，公司名称必填
        if (this.internalInfo.sub_type === '卖壳' && !this.internalInfo.companyName) {
          return false;
        }
      }
      
      // 委托定增：sub_type 和公司名称必填
      if (this.businessType === '委托定增') {
        if (!this.internalInfo.sub_type || !this.internalInfo.companyName) {
          return false;
        }
      }
      
      // 委托调研：子类型和公司名称必填
      if (this.businessType === '委托调研') {
        if (!this.internalInfo.sub_type || !this.internalInfo.companyName) {
          return false;
        }
      }
      
      return basicValid;
    }
  },
  data() {
    return {
      // 合并用户信息 + 其他信息（可编辑）
      internalInfo: {
        ...this.userInfo,
        ...this.info,
        sub_type: '', // 业务子类：买壳/卖壳
        companyName: '', // 公司名称
        companyCode: '', // 公司代码
        companyId: '', // 公司ID
        selectedCompCode: null // 用于 el-select 的 v-model
      },
      companyList: [], // 存储搜索结果
      searchLoading: false // 搜索加载状态
    };
  },
  watch: {
    // 监听 compExch props 变化
    compExch(newVal) {
      console.log('[弹窗 watch] compExch 变化:', newVal);
    },
    // 监听父组件传入的userInfo变化，同步更新默认值
    userInfo: {
      handler(newVal) {
        this.internalInfo = { 
          ...newVal, 
          ...this.info,
          sub_type: '',
          companyName: '',
          companyCode: '',
          companyId: '',
          selectedCompCode: null
        };
      },
      deep: true,
      immediate: true // 初始加载时同步
    },
    visible(newVal) {
      //console.log('[弹窗 watch] visible 变化:', newVal, ', 当前 compExch:', this.compExch);
      if (!newVal) {
        // 弹窗关闭时重置所有字段
        this.internalInfo = { 
          ...this.userInfo, 
          ...this.info,
          sub_type: '',
          companyName: '',
          companyCode: '',
          companyId: '',
          selectedCompCode: null
        };
        this.companyList = [];
      }
    },
    // 监听businessType变化，重置 sub_type 和公司信息
    businessType() {
      this.internalInfo.sub_type = '';
      this.internalInfo.companyName = '';
      this.internalInfo.companyCode = '';
      this.internalInfo.companyId = '';
      this.internalInfo.selectedCompCode = null;
      this.companyList = [];
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false);
      this.$emit('on-close');
    },
    handleConfirm() {
      const userStore = useUserStore();
      
      //console.log('[弹窗提交] 接收到的 compExch props:', this.compExch);
      //console.log('[弹窗提交] businessType:', this.businessType);
      
      // 业务类型映射
      const businessTypeMap = {
        '委托定增': 1,
        '委托卖/买壳': 2,
        '立项': 3,
        '委托调研': 4
      };
      
      // 构造基本提交数据
      const submitData = {
        username: this.internalInfo.projectContact,
        phone: this.internalInfo.contactPhone,
        email: this.internalInfo.contactEmail,
        business_type: businessTypeMap[this.businessType] || 0,
        business_desc: this.internalInfo.business_desc || '',
        creator_id: userStore.userId || '', // 使用用户ID而不是名字
        businessType: this.businessType // 保留业务类型名称用于显示
      };
      
      // 添加 comp_exch 参数（必填项）
      if (this.businessType === '委托定增' || this.businessType === '委托卖/买壳') {
        // 定增和壳交易固定为新三板
        submitData.comp_exch = 'NQ';
        console.log('[弹窗提交] 设置 comp_exch 为 NQ（定增/壳交易）');
      } else if (this.businessType === '委托调研' || this.businessType === '立项') {
        // 委托调研和立项从父组件传入
        submitData.comp_exch = this.compExch || '';
        console.log('[弹窗提交] 从 props 设置 comp_exch:', submitData.comp_exch);
      }
      
      console.log('[弹窗提交] 最终提交数据:', submitData);
      
      // 立项：添加公司信息
      if (this.businessType === '立项' && this.companyInfo) {
        submitData.comp_id = this.companyInfo.compId;
        submitData.project_id = this.internalInfo.project_id || ''; // 如果有项目 ID
      }
      
      // 委托卖/买壳：添加 sub_type
      if (this.businessType === '委托卖/买壳') {
        submitData.sub_type = this.internalInfo.sub_type || '';
        
        // 选择卖壳时，添加公司 ID
        if (this.internalInfo.sub_type === '卖壳' && this.internalInfo.companyId) {
          submitData.comp_id = this.internalInfo.companyId;
        }
      }
      
      // 委托定增：添加 sub_type 和公司 ID
      if (this.businessType === '委托定增') {
        submitData.sub_type = this.internalInfo.sub_type || '';
        if (this.internalInfo.companyId) {
          submitData.comp_id = this.internalInfo.companyId;
        }
      }
      
      // 委托调研：添加 sub_type 和公司 ID
      if (this.businessType === '委托调研') {
        submitData.sub_type = this.internalInfo.sub_type || '';
        if (this.internalInfo.companyId) {
          submitData.comp_id = this.internalInfo.companyId;
        }
      }
      
      this.$emit('on-confirm', submitData);
      this.handleClose();
    },
    // 电话输入限制：仅允许数字
    handlePhoneInput(e) {
      e.target.value = e.target.value.replace(/\D/g, ''); // 过滤非数字字符
      this.internalInfo.contactPhone = e.target.value;
    },
    // 邮箱格式验证
    validateEmail(email) {
      const reg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return reg.test(email);
    },
    // 邮箱输入过滤：去除首尾空格
    handleEmailInput(e) {
      e.target.value = e.target.value.trim();
      this.internalInfo.contactEmail = e.target.value;
    },
    
    // 公司搜索方法
    async handleCompanySearch(query) {
      this.companyList = []; // 每次搜索前先清空旧数据
      if (!query.trim()) {
        this.companyList = [];
        return;
      }
      
      this.searchLoading = true;
      try {
        const params = {};
        
        // 委托定增和卖壳：限制为新三板（NQ）
        if (this.businessType === '委托定增' || (this.businessType === '委托卖/买壳' && this.internalInfo.sub_type === '卖壳')) {
          params.comp_exch = 'NQ';
        }
        // 委托调研：使用父组件传入的 compExch
        else if (this.businessType === '委托调研' && this.compExch) {
          params.comp_exch = this.compExch;
        }
        
        const isNumber = /^\d+$/.test(query.trim());
        
        if (isNumber) {
          // 输入的是数字，按公司代码搜索
          params.comp_code = query.trim();
          params.page_size = 50;
        } else {
          // 输入的是文字，按公司名称搜索
          params.comp_name = query.trim();
          params.comp_fullname = query.trim();
        }
        
        const response = await companyApi.getCompanyBase(params);
        
        if (response && response.list) {
          this.companyList = response.list;
        } else {
          this.companyList = [];
        }
      } catch (error) {
        console.error('搜索公司信息失败:', error);
        this.$message.error('搜索失败，请稍后重试');
        this.companyList = [];
      } finally {
        this.searchLoading = false;
      }
    },
    
    // 公司选择方法
    handleCompanySelect(selectedCompCode) {
      if (selectedCompCode && this.companyList.length > 0) {
        const selectedCompany = this.companyList.find(item => item.comp_code === selectedCompCode);
        if (selectedCompany) {
          this.internalInfo.companyId = selectedCompany.row_id;
          this.internalInfo.companyCode = selectedCompany.comp_code;
          this.internalInfo.companyName = selectedCompany.comp_name;
        }
      } else {
        // 清空选择
        this.internalInfo.companyId = '';
        this.internalInfo.companyCode = '';
        this.internalInfo.companyName = '';
      }
    }
  },
};
</script>

<style scoped>
/* 遮罩层样式 */
.confirm-research-modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

/* 弹窗容器样式 */
.confirm-research-modal {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  width: 550px;
  padding: 20px;
  display: flex;
  flex-direction: column;
}

/* 弹窗头部样式 */
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.modal-title-wrap {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

/* 保留原始提示语样式 */
.prompt-text {
  font-size: 16px;
  color: #333;
  display: flex;
  align-items: center;
  gap: 8px;
}

/* 本地图片图标样式：控制大小和对齐 */
.headset-icon {
  width: 20px; /* 与原SVG大小一致 */
  height: 20px;
  object-fit: contain; /* 保持图片比例，避免拉伸 */
  vertical-align: middle;
}

/* 动态业务标题样式 */
.business-subtitle {
  font-size: 16px;
  font-weight: bold;
  color: #1890ff;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #999;
}

.close-btn:hover {
  color: #333;
}

/* 弹窗内容样式 */
.modal-content {
  margin-bottom: 20px;
}

/* 信息项容器：改为块级布局，确保输入框右对齐一致 */
.info-item {
  margin-bottom: 18px;
  padding-bottom: 8px;
  display: flex;
  flex-wrap: wrap; /* 适配小屏幕换行 */
  gap: 12px;
}

/* 标签样式：固定宽度+右对齐，确保输入框起始位置一致 */
.info-label {
  display: inline-block;
  width: 80px;
  color: #666;
  flex-shrink: 0; /* 标签宽度固定，不挤压 */
  text-align: right; /* 标签文字右对齐 */
  padding-right: 8px; /* 标签与输入框间距 */
}

/* 只读信息值样式（立项时的公司名称） */
.info-value {
  font-size: 14px;
  color: #333;
  font-weight: 500;
  padding: 6px 0;
  line-height: 1.5;
}

/* 可编辑输入框基础样式 */
.info-input {
  padding: 6px 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  color: #333;
  box-sizing: border-box;
}

/* 对接人输入框宽度 */
.info-input:not(.phone-input):not(.email-input) {
  width: 140px;
}

/* 电话输入框：宽度固定，与特殊说明右对齐 */
.phone-input {
  width: 120px;
}

/* 公司名称输入框：与邮箱宽度一致 */
.company-name-input {
  width: 75%;
  min-width: 200px;
}

/* 公司选择器样式 */
.company-select {
  width: 75%;
  min-width: 200px;
}

/* 邮箱输入框：与特殊说明宽度一致（75%） */
.email-input {
  width: 75%;
  min-width: 200px; /* 最小宽度，避免过窄 */
}

/* 特殊说明文本域：保持原有宽度，与邮箱输入框一致 */
.special-note {
  width: 75%;
  min-height: 80px;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 8px;
  box-sizing: border-box;
  resize: vertical;
  font-size: 14px;
  color: #333;
}

/* 单选框组样式 */
.radio-group {
  display: flex;
  gap: 20px;
  align-items: center;
}

.radio-label {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-size: 14px;
  color: #333;
}

.radio-label input[type="radio"] {
  cursor: pointer;
  width: 16px;
  height: 16px;
}

.radio-label:hover {
  color: #1890ff;
}

/* 适配小屏幕：当标签+输入框超出宽度时，输入框独占一行 */
@media (max-width: 500px) {
  .email-input, .special-note {
    width: 100%;
  }
  .info-item {
    flex-direction: column;
    align-items: flex-start;
  }
  .info-label {
    text-align: left;
    padding-right: 0;
    margin-bottom: 4px;
  }
}

.modifiable-tip {
  font-size: 12px;
  color: #999;
  margin-top: 8px;
}

.contact-phone {
  text-align: right;
  font-size: 12px;
  color: #999;
  margin-top: 10px;
}

/* 弹窗底部样式 */
.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.btn {
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  border: 1px solid #ddd;
}

.cancel-btn {
  background-color: #fff;
  color: #333;
}

.cancel-btn:hover {
  background-color: #f5f5f5;
}

.confirm-btn {
  background-color: #1890ff;
  color: #fff;
  border-color: #1890ff;
}

.confirm-btn:hover {
  background-color: #096dd9;
  border-color: #096dd9;
}

/* 禁用状态按钮样式 */
.confirm-btn:disabled {
  background-color: #87ceeb;
  border-color: #87ceeb;
  cursor: not-allowed;
}

/* 输入框聚焦样式优化 */
.info-input:focus, .special-note:focus {
  outline: none;
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1);
}
</style>